import { compose } from "redux"
import { filter, identity } from "ramda"
import middlewareEnhancer from "app/state/middleware"

const devtoolsEnhancer = window.__REDUX_DEVTOOLS_EXTENSION__

export default compose(...filter(identity, [middlewareEnhancer, devtoolsEnhancer]))
